/* Newest first / Oldest first on the All frames grid.

   WHY THIS IS A SEPARATE FILE. The sort list (SORTS) and the comparator
   (applySort) both live inside sf-claude.js, which is minified. Adding two
   entries there means rewriting a 28KB build artefact to change two lines,
   and a slip in that file takes down the whole storefront. This adds the
   two options from outside instead, and touches nothing that already works.

   WHY IT WATCHES THE GRID. An earlier attempt at extra sorting — the file
   this replaces — only wrapped SF.setSort, and the note left behind says
   why it was abandoned: renderShop re-sorts on every filter change, so the
   wrapper's order survived until the shopper touched a filter and then
   silently reverted to Featured. Wrapping the entry point is not enough
   when something else re-renders afterwards.

   So the order is re-applied whenever the grid changes, from a
   MutationObserver, and the observer ignores its own writes through the
   `busy` flag — without that, reordering children triggers the observer
   which reorders again, forever.

   THE MENU IS REBUILT BY renderShop TOO, so the two options are re-appended
   on the same signal rather than once at load.

   SORTING IS ON data-created, the newest colourway in each family. See
   sf-collections for why that date and not the collection's own.

   Families with no date sort to the end in both directions: unknown is not
   the same as old, and it should never outrank a real date. */
(function(){
"use strict";

var NEW = 'Newest first', OLD = 'Oldest first';
var busy = false;

function $(id){ return document.getElementById(id) }
function current(){ var l = $('sortLbl'); return l ? l.textContent.trim() : '' }
function mine(){ var c = current(); return c === NEW || c === OLD }

/* Add the two entries to the sort menu, in the order a shopper expects:
   after Best selling, before the price options. */
function ensureOptions(){
  var menu = $('sortmenu');
  if(!menu || !menu.children.length) return;
  if(menu.querySelector('[data-datesort]')) return;

  var tick = '<svg viewBox="0 0 24 24"><path d="m5 13 4 4L19 7"/></svg>';
  var model = menu.children[0];

  function build(label){
    var el = model.cloneNode(false);
    el.setAttribute('data-datesort','1');
    el.setAttribute('onclick', "SF.setSort('" + label + "')");
    el.innerHTML = (current() === label ? tick : '') + label;
    return el;
  }

  /* Insert before the first price option, or at the end if the labels ever
     change and none is found. */
  var before = null, kids = menu.children, i;
  for(i=0;i<kids.length;i++){
    if(kids[i].textContent.indexOf('Price') > -1){ before = kids[i]; break }
  }
  var a = build(NEW), b = build(OLD);
  if(before){ menu.insertBefore(a, before); menu.insertBefore(b, before); }
  else { menu.appendChild(a); menu.appendChild(b); }
}

function reorder(){
  if(!mine()) return;
  var grid = $('famGrid');
  if(!grid) return;

  var items = [].slice.call(grid.children).filter(function(el){
    return el.classList && el.classList.contains('fam-wrap');
  });
  if(items.length < 2) return;

  var newest = current() === NEW;
  items.sort(function(a, b){
    var ta = +a.dataset.created || 0, tb = +b.dataset.created || 0;
    if(!ta && !tb) return 0;
    if(!ta) return 1;          /* no date: last, either way round */
    if(!tb) return -1;
    return newest ? tb - ta : ta - tb;
  });

  /* Already in order? Then leave the DOM alone — rewriting it on every
     observation is what makes a grid flicker. */
  var same = true;
  for(var i=0;i<items.length;i++){
    if(grid.children[i] !== items[i]){ same = false; break }
  }
  if(same) return;

  busy = true;
  var frag = document.createDocumentFragment();
  items.forEach(function(el){ frag.appendChild(el) });
  grid.appendChild(frag);
  busy = false;
}

function sync(){ ensureOptions(); reorder(); }

document.addEventListener('DOMContentLoaded', function(){
  var grid = $('famGrid');
  if(!grid) return;          /* not the All frames page */

  sync();

  var mo = new MutationObserver(function(){
    if(busy) return;
    sync();
  });
  mo.observe(grid, { childList:true });

  var menu = $('sortmenu');
  if(menu) new MutationObserver(function(){ if(!busy) ensureOptions(); })
    .observe(menu, { childList:true });
});
})();